import { cn } from "../cn";

/** Superfície padrão de inputs, selects e triggers de formulário. */
export const formControlSurfaceClass = "bg-background";

const formControlFocusClass =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 focus-visible:ring-offset-background";

const formControlDisabledClass =
  "disabled:cursor-not-allowed disabled:opacity-50";

/**
 * Texto digitado no produto estreito do web (TAM-262): os 16px do `text-field`
 * do app — o web estreito copia as proporções do app, e abaixo de 16px o
 * Safari do iPhone dá zoom ao focar o campo. Preso ao `html.app-scale` do web,
 * para o desktop com janela estreita não mudar.
 */
const formControlAppScaleTextClass = "[.app-scale_&]:max-lg:text-field";

/** Campo de texto (`Input`). */
export const formControlInputClass = cn(
  "flex h-10 w-full rounded-md border border-input px-3 py-2 text-sm ring-offset-background",
  formControlAppScaleTextClass,
  formControlSurfaceClass,
  "file:border-0 file:bg-transparent file:text-sm file:font-medium",
  "placeholder:text-muted-foreground",
  formControlFocusClass,
  formControlDisabledClass,
);

/** Área de texto (`Textarea`). */
export const formControlTextareaClass = cn(
  "flex min-h-[80px] w-full rounded-md border border-input px-3 py-2 text-sm ring-offset-background",
  formControlAppScaleTextClass,
  formControlSurfaceClass,
  "placeholder:text-muted-foreground",
  formControlFocusClass,
  formControlDisabledClass,
);

/**
 * Trigger sem caixa, para metadados embutidos em superfícies de conteúdo
 * (ex.: a faixa do Creator no editor de notas). Aplicar por cima do trigger
 * padrão — depende do `cn` final dos componentes para vencer as classes base.
 */
export const formControlGhostTriggerClass = cn(
  "h-auto w-auto max-w-full justify-start gap-2 rounded-md border-0 px-1.5 py-1",
  "bg-transparent shadow-none hover:bg-accent/40",
  "focus:ring-offset-0 focus-visible:ring-offset-0",
);

/** Trigger de select/combobox/date picker. */
export const formControlTriggerClass = cn(
  "flex h-10 w-full items-center justify-between rounded-md border border-input px-3 py-2 text-sm ring-offset-background",
  formControlSurfaceClass,
  "placeholder:text-muted-foreground",
  "focus:outline-none focus:ring-2 focus:ring-primary/50 focus:ring-offset-2 focus:ring-offset-background",
  formControlDisabledClass,
);
